import { AfterViewInit, Component, ElementRef, Input, OnChanges, OnDestroy, ViewChild } from '@angular/core';
import { TimezoneAwareDatePipe } from '@twaice-fe/frontend/shared/services';
import { ECharts, init } from 'echarts';
import { NzEmptyComponent } from 'ng-zorro-antd/empty';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { AlertPanelModule } from '../alert-panel/alert-panel.module';
import { BreachHistoryChartService } from './breach-history-chart.service';
import { BreachHistoryEvaluation, BreachHistoryWindow } from './breach-history-chart.types';

@Component({
  selector: 'twaice-fe-breach-history-chart',
  templateUrl: './breach-history-chart.component.html',
  providers: [BreachHistoryChartService, TimezoneAwareDatePipe],
  imports: [AlertPanelModule, NzEmptyComponent, NzSpinModule],
})
export class BreachHistoryChartComponent implements AfterViewInit, OnChanges, OnDestroy {
  @Input() evaluations: BreachHistoryEvaluation[] | null = null;
  @Input() lookbackDays = 0;
  @Input() requestedWindow: BreachHistoryWindow | null = null;
  @Input() storageTimezone: string | null = null;
  @Input() isLoading = false;
  @Input() isEmpty = false;
  @Input() isError = false;

  @ViewChild('chart', { static: true }) chartContainer: ElementRef<HTMLDivElement>;

  private chartInstance: ECharts | null = null;
  private resizeObserver: ResizeObserver | null = null;

  constructor(private chartService: BreachHistoryChartService) {}

  get isHidden(): boolean {
    return this.isEmpty || this.isError || this.isLoading;
  }

  ngAfterViewInit(): void {
    this.chartInstance = init(this.chartContainer.nativeElement, null, { renderer: 'svg' });
    this.resizeObserver = new ResizeObserver(() => this.chartInstance?.resize());
    this.resizeObserver.observe(this.chartContainer.nativeElement);
    this.render();
  }

  ngOnChanges(): void {
    this.render();
  }

  ngOnDestroy(): void {
    this.resizeObserver?.disconnect();
    this.chartInstance?.dispose();
  }

  private render(): void {
    if (!this.chartInstance || !this.evaluations || !this.lookbackDays) return;
    this.chartInstance.setOption(
      this.chartService.getEvaluationsChartOptions(
        this.evaluations,
        this.lookbackDays,
        this.requestedWindow,
        this.storageTimezone
      )
    );
  }
}
